class dataService {
    constructor() {
        this.data = {
            showFirstPart: {hidden: ''},
            showTooltip: {hidden: ''},
            showSecondPart: {hidden: 'hidden'},
            showThirdPart: {hidden: 'hidden'},
            showForthPart: {hidden: 'hidden'},
            showFifthPart: {hidden: ''},
            lightboxIsOpen: false,
            visibleTooltip: true,
            myReferer : "Direct Access, No Referrer",
            clientProfile: {
                // test: false,
                monthlyBill: 525,
                monthlyBillkWh: 0,
                email: "",
                fullName: '',
                pin: '',
                phone: "",
                address: '',
                dailyTrip: '0',
                mpg: '0',
                carYear: "0",
                carMake: "make",
                carModel: "model",
                saveAmount: '',
                selectedSystem: {
                    selectsSystem: false,
                    system_type: "N/A",
                    system_to_display: "Optimal",
                    savingsAmount: '',
                    installFee: '',
                    monthly_loan_payment: '',
                    cashorloan: "N/A",
                    payback: 0,
                    loan_payback: 0
                },
                cost_per_watt : 0,
                num_of_modules : 0,
                module_watts : 435,
                system_size : 0,
                gross_cost : 0,
                fed_itc : 0.50,
                net_cost : 0,
                gross_cost_per_watt : 0,
                net_cost_per_watt : 0,
                loan_term_years : 12,
                net_energy_meter_fee : 132,
                marketing_commision : 0,
                system_base_cost : 0,
                apr : 0.0699, // bankrate.com 15 year home equity line of credit(loan)
                monthly_payments : 0
            },
            chartData: {
                Optimal: {
                    system_type: 'Default',
                    system_cost: 999999,
                    payback: 999,
                    loan_payback: 99,
                    savingsAmount: 0,
                    installFee: 0,
                    monthly_loan_pmt: 0,
                    cashorloan: ''
                },
                Baseline: {
                    data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                    loanData: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                    visible: true
                },
                Economy: {
                    data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                    payback: 0,
                    loanData: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                    loan_payback: 0,
                    system_cost: 0,
                    visible: false,
                    savingsAmount: 0,
                    installFee: 0,
                    monthly_loan_pmt: 0
                },
                Compact: {
                    data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                    payback: 0,
                    loanData: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                    loan_payback: 0,
                    system_cost: 0,
                    visible: false,
                    savingsAmount: 0,
                    installFee: 0,
                    monthly_loan_pmt: 0
                },
                Intermediate: {
                    data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                    payback: 0,
                    loanData: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                    loan_payback: 0,
                    system_cost: 0,
                    visible: false,
                    savingsAmount: 0,
                    installFee: 0,
                    monthly_loan_pmt: 0
                },
                Standard: {
                    data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                    payback: 0,
                    loanData: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                    loan_payback: 0,
                    system_cost: 0,
                    visible: false,
                    savingsAmount: 0,
                    installFee: 0,
                    monthly_loan_pmt: 0
                },
                Premium: {
                    data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                    payback: 0,
                    loanData: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                    loan_payback: 0,
                    system_cost: 0,
                    visible: false,
                    savingsAmount: 0,
                    installFee: 0,
                    monthly_loan_pmt: 0
                },
                Selected_EVPV: {
                    data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                    payback: 0,
                    loanData: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                    loan_payback: 0,
                    system_cost: 0,
                    visible: false,
                    savingsAmount: 0,
                    installFee: 0,
                    monthly_loan_pmt: 0
                },
                EV_Rate_Charging: {
                    data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                    payback: 0,
                    loanData: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                    vehiclefuel_yr: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                    loan_payback: 0,
                    system_cost: 0,
                    visible: false,
                    savingsAmount: 0,
                    installFee: 0,
                    monthly_loan_pmt: 0
                }
            },
        };

        this.subcribers = [];
    }

    onValuesChanged(fn) {
        this.subcribers.push(fn);
    }

    updateAll() {
        this.subcribers.forEach(item => item(this.data));
    }

    showHeader() {
        var querystring = window.location.search
        if( querystring === '?campaign=EC1&v=nh' || querystring === '?campaign=SC3&v=nh' ){
            return false;
        }
        return true;
    }

    billUpdater = (bill) => {
        let clientProfile = this.data.clientProfile;
        console.log("Monthly bill updated to:"+bill);
        clientProfile.monthlyBill = bill;
        this.data.clientProfile = clientProfile;
        this.updateAll();
      };

    paymentTypeUpdater = (paymentType) => {
        let clientProfile = this.data.clientProfile;
        clientProfile.selectedSystem.cashorloan = paymentType;
        this.data.clientProfile = clientProfile;
        this.updateAll();
      };

    updateAddress(address){
        let clientProfile = this.data.clientProfile;
        clientProfile.address = address;
        this.data.clientProfile = clientProfile;
        this.updateAll();
    }

    hideChanger = (input) => {
        console.log("Comes in Hide Changer func");
        console.log("input is:"+input);
        if (input === 'showThirdPart') {
            console.log("Resetting state");
            this.data.showFirstPart.hidden= 'hidden';
            this.data.showTooltip.hidden= 'hidden';
            this.data.showSecondPart.hidden='hidden';
            this.data.showThirdPart.hidden='hidden';
            this.data.showForthPart.hidden='hidden';
            this.data.showFifthPart.hidden='';
            this.data[input].hidden='';
            document.body.classList.add('isThankYou');
            this.updateAll();
        }
        else {
            console.log("SHOULD NEVER COME HERE!!");
            this.data[input].hidden='hidden';
            this.updateAll();
        }
    };

    showAllParts(){
        this.data.showFirstPart.hidden =  '';
        this.data.showTooltip.hidden =  '';
        this.data.showSecondPart.hidden =  ''; // Second Page
        this.data.showThirdPart.hidden =  'hidden'; // Third page
        this.data.showForthPart.hidden =  'hidden';
        this.data.showFifthPart.hidden =  ''; // Blog Thumbnails

        this.updateAll();
}

    showForthPart = () => {
        console.log("Coming in here to update page display views");
        this.data.showFirstPart.hidden = 'hidden' ;
        this.data.showTooltip.hidden = 'hidden' ;
        this.data.showSecondPart.hidden = 'hidden';  // Second Page
        this.data.showThirdPart.hidden = 'hidden';  // Third page
        this.data.showForthPart.hidden = '';   // custom Makello Form
        this.data.showFifthPart.hidden = 'hidden';  // Blog Thumbnails
        this.data.visibleTooltip = false ; // Blog Thumbnails

        this.updateAll();
    }

    selectedSystemUpdater = (system_selected) => {
        let clientProfile = this.data.clientProfile;
        clientProfile.saveAmount = this.data.chartData.Optimal.savingsAmount;
        clientProfile.selectedSystem.system_type = system_selected;
        clientProfile.selectedSystem.system_to_display = system_selected;

        if (system_selected !== "Optimal") {
            var customer_selects_preffered_system = true;
        }

        switch (system_selected) {
            case ("Optimal"):
                clientProfile.selectedSystem.savingsAmount = this.data.chartData.Optimal.savingsAmount;
                clientProfile.selectedSystem.installFee = this.data.chartData.Optimal.installFee;
                clientProfile.selectedSystem.monthly_loan_payment = this.data.chartData.Optimal.monthly_loan_pmt;
                clientProfile.selectedSystem.payback = this.data.chartData.Optimal.payback;
                customer_selects_preffered_system = false;
                break;
            case ("Economy"):
                clientProfile.selectedSystem.savingsAmount = this.data.chartData.Economy.savingsAmount;
                clientProfile.selectedSystem.installFee = this.data.chartData.Economy.installFee;
                clientProfile.selectedSystem.monthly_loan_payment = this.data.chartData.Economy.monthly_loan_pmt;
                clientProfile.selectedSystem.payback = this.data.chartData.Economy.payback;
                break;
            case ("Compact"):
                clientProfile.selectedSystem.savingsAmount = this.data.chartData.Compact.savingsAmount;
                clientProfile.selectedSystem.installFee = this.data.chartData.Compact.installFee;
                clientProfile.selectedSystem.monthly_loan_payment = this.data.chartData.Compact.monthly_loan_pmt;
                clientProfile.selectedSystem.payback = this.data.chartData.Compact.payback;
                break;
            case ("Intermediate"):
                clientProfile.selectedSystem.savingsAmount = this.data.chartData.Intermediate.savingsAmount;
                clientProfile.selectedSystem.installFee = this.data.chartData.Intermediate.installFee;
                clientProfile.selectedSystem.monthly_loan_payment = this.data.chartData.Intermediate.monthly_loan_pmt;
                clientProfile.selectedSystem.payback = this.data.chartData.Intermediate.payback;
                break;
            case ("Standard"):
                clientProfile.selectedSystem.savingsAmount = this.data.chartData.Standard.savingsAmount;
                clientProfile.selectedSystem.installFee = this.data.chartData.Standard.installFee;
                clientProfile.selectedSystem.monthly_loan_payment = this.data.chartData.Standard.monthly_loan_pmt;
                clientProfile.selectedSystem.payback = this.data.chartData.Standard.payback;
                break;
            case ("Premium"):
                clientProfile.selectedSystem.savingsAmount = this.data.chartData.Premium.savingsAmount;
                clientProfile.selectedSystem.installFee = this.data.chartData.Premium.installFee;
                clientProfile.selectedSystem.monthly_loan_payment = this.data.chartData.Premium.monthly_loan_pmt;
                clientProfile.selectedSystem.payback = this.data.chartData.Premium.payback;
                break;
            case ("Solar + Plug-In Vehicle"):
                clientProfile.selectedSystem.savingsAmount = this.data.chartData.Selected_EVPV.savingsAmount;
                clientProfile.selectedSystem.installFee = this.data.chartData.Selected_EVPV.installFee;
                clientProfile.selectedSystem.monthly_loan_payment = this.data.chartData.Selected_EVPV.monthly_loan_pmt;
                clientProfile.selectedSystem.payback = this.data.chartData.Selected_EVPV.payback;
                break;
            case ("Plug-In Vehicle"):
                clientProfile.selectedSystem.savingsAmount = this.data.chartData.EV_Rate_Charging.savingsAmount;
                clientProfile.selectedSystem.installFee = this.data.chartData.EV_Rate_Charging.installFee;
                clientProfile.selectedSystem.monthly_loan_payment = this.data.chartData.EV_Rate_Charging.monthly_loan_pmt;
                clientProfile.selectedSystem.payback = this.data.chartData.EV_Rate_Charging.payback;
                break;
            default:
                break;
        }
        clientProfile.selectedSystem.selectsSystem = customer_selects_preffered_system;
        this.data.clientProfile = clientProfile;
        this.updateAll();
    }

    updateChartData(data) {
        this.data.chartData = data;
        this.updateAll();
    }

    resetOptimalSystem = () => {
        this.data.chartData.Optimal.system_type = 'Default';
        this.data.chartData.Optimal.system_cost = 999999;
        this.data.chartData.Optimal.payback = 999;
        this.data.chartData.Optimal.loan_payback = 99;
        this.data.chartData.Optimal.savingsAmount = 0;
        this.data.chartData.Optimal.installFee = 0;
        this.data.chartData.Optimal.monthly_loan_pmt = 0;
        this.data.chartData.Optimal.cashorloan = '';

        return {...this.data.chartData};
    }

    toggleLightBox() {
        this.data.lightboxIsOpen = false ; // !this.data.lightboxIsOpen;
        this.updateAll();
    }

    static getInstance() {
        if(this.instance) return this.instance;
        else {
            this.instance = new dataService();
            return this.instance;
        }
    }

    updateReferer(){
        if (document.referrer != null){
            console.log("Confirming refferer");
            this.data.myReferer = document.referrer;
        }
        else{
            this.data.myReferer = "Direct Access, No Referrer";
        }
        console.log(this.data.myReferer);
        this.updateAll();
    }
}

const instance = dataService.getInstance();

export default instance;
